import {
  SelectForm,
  Error,
  CancelButton,
  SubmitButton,
  InputForm,
} from "components";
import { FeaturedAdsEnum } from "props/enum";
import FeaturedVideoForm from "./FeaturedVideoForm";
import FeaturedImageForm from "./FeaturedImage";
import { FeaturedAdsInput, FeaturedAdsInputError } from "modules/featured_ads/state/actionType";

interface FormProps {
  formData: FeaturedAdsInput;
  formError: FeaturedAdsInputError;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  handleSubmit: React.MouseEventHandler<HTMLButtonElement>;
  loading: boolean;
  header: string;
  onClose: () => void;
  handleVideoFileChange: (file: File) => void;
  handleImageFileChange: (file: File) => void;
  isNewVideo: boolean;
   posterUrl: string | null;
}
const FeaturedAdsForm: React.FC<FormProps> = ({
  formData,
  formError,
  handleChange,
  handleSubmit,
  loading,
  header,
  onClose,
  handleVideoFileChange,
  isNewVideo,
  handleImageFileChange,
  posterUrl
}) => {
  return (
    <>
      <div className="px-4">
        <h2 className="w-full text-center font-bold text-2xl pb-4">{header}</h2>
        <form>
          <div className="grid grid-cols-2 gap-4">
            <div className="">
            <InputForm
              label="Featured Ads name"
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
            {formError?.name && <Error>{formError.name}</Error>}
          </div>
          <div className="">
            <InputForm
              label="Featured Order"
              type="number"
              id="featured_order"
              name="featured_order"
              value={formData.featured_order}
              onChange={handleChange}
            />
            {formError?.featured_order && <Error>{formError.featured_order}</Error>}
          </div>
          </div>
          <div className="">
            <SelectForm
              label="Featured Ads Type"
              type="text"
              value={formData.featured_type}
              id="featured_type"
              name="featured_type"
              option={Object.values(FeaturedAdsEnum).map((value) => (
                <option key={value} value={value}>
                  {value}
                </option>
              ))}
              onChange={handleChange}
            />
            {formError.featured_type && (
              <Error>{formError.featured_type}</Error>
            )}
          </div>
          {formData.featured_type === FeaturedAdsEnum.image && (
            <>
              <FeaturedImageForm
                formData={formData}
                formError={formError}
                handleImageFileChange={handleImageFileChange}
              />
            </>
          )}
          {formData.featured_type === FeaturedAdsEnum.video && (
            <>
              <FeaturedVideoForm
                error={formError.video}
                handleVideoFileChange={handleVideoFileChange}
                isNewVideo={isNewVideo}
                posterUrl={posterUrl}
              />
            </>
          )}
          <div className="w-full flex items-center justify-between px-5 mt-4">
            <CancelButton onClick={onClose} type="button" />
            <SubmitButton
              onClick={handleSubmit}
              loading={loading}
              loadingText="Uploading..."
              type="submit"
            />
          </div>
        </form>
      </div>
    </>
  );
};
export default FeaturedAdsForm;
